import { IStore } from '../index'

export const getLoginValue = (state: IStore) => state.loginReducer
